<template>
  <div>
    <importDialog
      :dialog="dialog"
      @close="dialog = false"
      @add="importLinkedin"
    />
    <importStructure
      :structure="structure"
      :dialog="structure_dialog"
      @close="structure_dialog = false"
      @add="addStructure"
    />
    <v-card
      v-if="post"
      :style="{
        borderBottom: '3px solid #272727',
        borderLeft: '1px solid #272727',
        borderTop: '1px solid #272727',
        borderRight: '3px solid #272727',
        borderRadius: '6px',
      }"
    >
      <div
        class="px-3 pt-3 align-center"
        style="display: grid; grid-template-columns: 50px auto 40px"
      >
        <v-avatar
          v-if="a"
          :image="
            a.profile_picture.src ? a.profile_picture.src : a.profile_picture
          "
          size="40"
          variant="outlined"
        ></v-avatar>
        <v-avatar v-else size="40" class="bg-smoke"></v-avatar>
        <div>
          <p style="font-size: 11pt; font-weight: 600">
            {{ a?.name ? a.name : "Account" }}
          </p>
          <p style="font-size: 8pt">20,000 followers</p>
          <!-- TO DO Get followeres and add to get accounts call -->
          <p style="font-size: 8pt">
            1d - <v-icon size="10">mdi-earth</v-icon>
          </p>
        </div>
      </div>
      <div class="pa-4" style="font-size: 11pt">
        <div
          v-html="
            readmore || !readMoreEnabled
              ? cleanText.replace(/\n/g, '<br>')
              : partOne.replace(/\n/g, '<br>')
          "
        ></div>

        <span
          v-if="partTwo.length > 0 && readMoreEnabled"
          style="cursor: pointer; opacity: 0.6"
          @click="readmore = !readmore"
          >Read {{ readmore ? "less" : "more" }}</span
        >
      </div>

      <div class="media" v-if="post.media?.length > 0">
        <div
          v-if="post.media.length === 1 && post.media[0].extension === 'pdf'"
        >
          <embed
            :src="post.media[0].src"
            type="application/pdf"
            width="100%"
            height="400px"
          />
        </div>

        <v-img
          v-if="post.media.length === 1 && post.media[0].type === 'image'"
          :src="post.media[0].src"
        ></v-img>

        <v-img
          v-if="post.media.length === 1 && post.media[0].type === 'template'"
          :src="post.media[0].thumbnail"
        ></v-img>

        <v-img
          v-if="post.media.length === 1 && post.media[0].type === 'stock'"
          :src="post.media[0].src"
        ></v-img>

        <div
          class="pa-3"
          v-if="post.media.length === 1 && post.media[0].type === 'url'"
        >
          <v-card
            @click="openLink(post.media[0].url)"
            variant="outlined"
            elevation="0"
            class="pa-2"
            style="
              display: grid;
              grid-template-columns: 1fr 2fr 40px;
              gap: 10px;
            "
          >
            <v-img
              v-if="post.media.length > 0"
              :src="post.media[0].thumbnail?.src || post.media[0].src"
              cover
            >
              <!-- <v-btn
                variant="flat"
                icon="mdi-link-variant"
                size="small"
                style="position: absolute; left: 10px; bottom: 10px"
                @click="openLink(post.media[0].url)"
              ></v-btn> -->
            </v-img>
            <div>
              <p style="font-size: 9pt; font-weight: 600">
                {{ post.media[0].title }}
              </p>
              <p style="font-size: 9pt; color: #8c8c8c" class="line-clamp">
                {{ getMediaUrl(post.media[0].url) }}
              </p>
            </div>
            <div class="d-flex align-center justify-center">
              <v-tooltip text="Remove link from post">
                <template v-slot:activator="{ props }">
                  <v-btn
                    v-bind="props"
                    @click.stop="$store.commit('setPostMedia', [])"
                    variant="text"
                    icon="mdi-delete"
                    size="x-small"
                  ></v-btn>
                </template>
              </v-tooltip>
            </div>
          </v-card>
        </div>

        <div
          v-else-if="post.media[0].type === 'video'"
          class="d-flex align-center justify-center"
        >
          <video
            :src="post.media[0].src"
            width="100%"
            muted
            autoplay
            @click="
              $event.target.paused
                ? $event.target.play()
                : $event.target.pause()
            "
          ></video>
        </div>
        <div
          v-else-if="post.media?.length === 2"
          style="display: grid; grid-template-columns: 1fr 1fr; gap: 2px"
        >
          <v-img
            v-for="m in post.media"
            :key="m.id"
            :src="m.src"
            contain
          ></v-img>
        </div>
        <div
          v-else-if="post.media?.length > 2"
          style="
            display: grid;
            grid-template-columns: 2fr 1fr;
            grid-template-rows: 1fr;
            gap: 2px;
          "
        >
          <v-img :src="post.media[0].src" cover></v-img>
          <v-img :src="post.media[1].src" cover></v-img>
          <v-img
            cover
            :src="post.media[2].src"
            style="grid-row-start: 1; grid-row-end: 3"
          ></v-img>
        </div>
      </div>
      <!-- <div class="article" v-else-if="p.content?.hasOwnProperty('article')">
        <v-img :src="p.content?.article?.src?.src">
          <v-btn
            variant="flat"
            icon="mdi-link-variant"
            size="small"
            style="position: absolute; left: 10px; bottom: 10px"
            @click="openLink(p.content?.article?.source)"
          ></v-btn>
        </v-img>
      </div> -->
      <div class="bottom">
        <v-divider></v-divider>
        <div class="d-flex justify-space-between px-2 py-1">
          <v-btn variant="text" size="small" prepend-icon="mdi-thumb-up-outline"
            >Like</v-btn
          >
          <v-btn variant="text" size="small" prepend-icon="mdi-comment-outline"
            >Comment</v-btn
          >

          <v-btn variant="text" size="small" prepend-icon="mdi-send-outline"
            >Send</v-btn
          >
        </div>
      </div>
    </v-card>
    <v-card
      v-else-if="p"
      :style="{
        borderBottom: '3px solid #272727',
        borderLeft: '1px solid #272727',
        borderTop: '1px solid #272727',
        borderRight: '3px solid #272727',
        borderRadius: '6px',
      }"
    >
      <div
        class="px-3 pt-3 align-center"
        style="display: grid; grid-template-columns: 50px auto 40px"
        v-if="a"
      >
        <v-avatar
          :image="
            a.profile_picture.src ? a.profile_picture.src : a.profile_picture
          "
          size="40"
          variant="outlined"
        ></v-avatar>
        <div>
          <p style="font-size: 11pt; font-weight: 600">
            {{ a.name }}
          </p>
          <p style="font-size: 8pt">20,000 followers</p>
          <!-- TO DO Get followeres and add to get accounts call -->
          <p style="font-size: 8pt">
            1d - <v-icon size="10">mdi-earth</v-icon>
          </p>
        </div>
        <v-menu offset-y>
          <template v-slot:activator="{ props }">
            <v-btn
              size="small"
              icon="mdi-dots-vertical"
              class="ml-1"
              v-bind="props"
              elevation="0"
              variant="text"
            >
            </v-btn>
          </template>

          <v-card>
            <v-list dense style="font-size: 11pt">
              <v-list-item link @click="openPost(p.id)">
                Open in LinkedIn
              </v-list-item>
              <v-list-item link @click="dialog = true">
                Import post
              </v-list-item>
              <v-list-item link @click="extractStructure">
                Save structure
              </v-list-item>
              <v-list-item link @click="deletePost"> Delete post </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </div>

      <div class="pa-4" style="font-size: 11pt">
        <div
          v-html="
            readmore
              ? cleanText.replace(/\n/g, '<br>')
              : partOne.replace(/\n/g, '<br>')
          "
        ></div>

        <span
          v-if="partTwo.length > 0"
          style="cursor: pointer; opacity: 0.6"
          @click="readmore = !readmore"
          >Read {{ readmore ? "less" : "more" }}</span
        >
      </div>
      <div class="media" v-if="p.content?.hasOwnProperty('media')">
        <div
          v-if="
            p.content.media.length === 1 &&
            p.content.media[0].src.type === 'document'
          "
        >
          <embed
            :src="p.content.media[0].src.src"
            type="application/pdf"
            width="100%"
            height="400px"
          />
        </div>
        <v-img
          v-if="
            p.content.media.length === 1 &&
            p.content.media[0].src.type === 'image'
          "
          :src="p.content?.media[0].src.src"
        ></v-img>

        <div
          v-else-if="p.content.media[0].src.type === 'video'"
          class="d-flex align-center justify-center"
        >
          <video
            :ref="`video-${p.content.media[0].id}`"
            :src="p.content.media[0].src.src"
            width="100%"
            muted
            autoplay
            @click="
              $event.target.paused
                ? $event.target.play()
                : $event.target.pause()
            "
          ></video>
        </div>
        <div
          v-else-if="p.content.media && p.content.media.length === 2"
          style="display: grid; grid-template-columns: 1fr 1fr; gap: 2px"
        >
          <v-img
            v-for="m in p.content.media"
            :key="m.id"
            :src="m.src"
            contain
          ></v-img>
        </div>
        <div
          v-else-if="p.content.media && p.content.media.length > 2"
          style="
            display: grid;
            grid-template-columns: 2fr 1fr;
            grid-template-rows: 1fr;
            gap: 2px;
          "
        >
          <v-img :src="p.content.media[0].src" cover></v-img>
          <v-img :src="p.content.media[1].src" cover></v-img>
          <v-img
            cover
            :src="p.content.media[2].src"
            style="grid-row-start: 1; grid-row-end: 3"
          ></v-img>
        </div>
      </div>
      <div class="article" v-else-if="p.content?.hasOwnProperty('article')">
        <v-img :src="p.content?.article?.src?.src">
          <v-btn
            variant="flat"
            icon="mdi-link-variant"
            size="small"
            style="position: absolute; left: 10px; bottom: 10px"
            @click="openLink(p.content?.article?.source)"
          ></v-btn>
        </v-img>
      </div>
      <div v-else-if="p.reshareContext?.parent">
        <p style="font-size: 9pt; text-align: end" class="mx-2">Reposted:</p>

        <v-card flat class="pa-2 ma-2" style="border: 1px solid #ebebef">
          <!-- <p>{{ p.reshareContext.post.author.localizedName }}</p>
          {{ p.reshareContext.post.commentary }} -->
          <v-btn block variant="text" @click="openPost(p.id)"
            >View reshared post</v-btn
          >
        </v-card>
      </div>
      <div class="bottom">
        <v-divider></v-divider>
        <div class="d-flex justify-space-between px-2 py-1">
          <v-btn variant="text" size="small" prepend-icon="mdi-thumb-up-outline"
            >Like</v-btn
          >
          <v-btn variant="text" size="small" prepend-icon="mdi-comment-outline"
            >Comment</v-btn
          >

          <v-btn variant="text" size="small" prepend-icon="mdi-send-outline"
            >Send</v-btn
          >
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
// import { DateTime } from "luxon";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { db } from "@/firebase";
import {
  collection,
  arrayUnion,
  addDoc,
  updateDoc,
  doc,
} from "firebase/firestore";
import importDialog from "../importDialog.vue";
import importStructure from "../importStructure.vue";

export default {
  components: {
    importDialog,
    importStructure,
  },
  props: {
    a: {
      type: Object,
      default: null,
    },
    p: {
      type: Object,
      default: null,
    },
    post: {
      type: Object,
      default: null,
    },
    readMoreEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      structure_dialog: false,
      structure: null,
      readmore: false,
    };
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      workspace: (state) => state.workspace.workspace,
    }),
    partTwo() {
      let t;
      if (this.p) {
        t = this.p.commentary.split(" ");
      } else if (this.post) {
        t = this.post.variation.text.split(" ");
      }

      return t.slice(15).join(" ");
    },
    cleanText() {
      let t;
      if (this.p) {
        t = this.p.commentary.replace(/@\[(.*?)\]\(.*?\)/g, "@$1");
      } else if (this.post && this.post.variation) {
        t = this.post.variation.text.replace(/@\[(.*?)\]\(.*?\)/g, "@$1");
      }

      return this.format(t);
    },
    partOne() {
      const words = this.cleanText.split(" ");
      return words.slice(0, 15).join(" ");
    },
  },
  methods: {
    async deletePost() {
      let r = confirm("Are you sure?");
      if (r) {
        this.$store.commit("setLoading", { type: "general", val: true });
        console.log("Deleting");
        //TO DO delete via function

        const linkedinDeletePost = httpsCallable(
          functions,
          "linkedinDeletePost",
        );
        const res = await linkedinDeletePost({
          postId: this.p.id,
          accountId: this.a.id,
        });
        this.$store.dispatch("fetchAccounts");
        this.$store.commit("setLoading", { type: "general", val: false });

        console.log(res);
      }
    },
    getMediaUrl(url) {
      console.log(url);

      let u = url;
      if (u.includes("http")) {
        u = u.split("//")[1];
      }
      if (u.includes("www")) {
        u = u.split("www.")[1];
      }
      return u;
    },
    async uploadFiles(url) {
      let upload = fetch(url);

      console.log(upload);
      var fileName = upload.name;
      var fileExtension = fileName.split(".").pop();
      const filesize = Math.floor(upload.size / 1024);

      function isType(fileExtension) {
        switch (fileExtension.toLowerCase()) {
          case "m4v":
            return "video";
          case "avi":
            return "video";
          case "mpg":
            return "video";
          case "mp4":
            return "video";
          case "jpg":
            return "image";
          case "gif":
            return "image";
          case "bmp":
            return "image";
          case "png":
            return "image";
          case "jpeg":
            return "image";
        }
        return null;
      }

      const storage = getStorage();

      const metadata = {
        contentType: upload.type,
      };
      const docRef = await addDoc(
        collection(db, "workspaces", this.userProfile.workspace, "media"),
        {
          title: fileName,
          extension: fileExtension,
          class: "media",
          created_at: Math.floor(Date.now() / 1000),
          created_by: this.userProfile.uid,
          created_by_email: this.userProfile.email,
          workspace: this.userProfile.workspace,
          size: filesize,
          posts: [],
          templates: [],
          tags: [],
          type: isType(fileExtension),
        },
      );
      const storageRef = ref(
        storage,
        `${this.userProfile.workspace}/media/${docRef.id}.${fileExtension}`,
      );

      await uploadBytesResumable(storageRef, upload, metadata);

      const downloadURL = await getDownloadURL(storageRef);
      const updateRef = doc(
        db,
        "workspaces",
        this.userProfile.workspace,
        "media",
        docRef.id,
      );

      await updateDoc(updateRef, {
        uid: docRef.id,
        url: downloadURL,
      });

      this.$store.commit("setNotification", {
        show: true,
        text: "Media added!",
        type: "primary",
        icon: "",
      });

      this.$store.dispatch("fetchMedia");
      this.search_loading = false;
    },
    async uploadFile(f) {
      console.log(f);
      function isType(fileExtension) {
        switch (fileExtension.toLowerCase()) {
          case "m4v":
            return "video";
          case "avi":
            return "video";
          case "mpg":
            return "video";
          case "mp4":
            return "video";
          case "jpg":
            return "image";
          case "gif":
            return "image";
          case "bmp":
            return "image";
          case "png":
            return "image";
          case "jpeg":
            return "image";
          case "pdf":
            return "document";
        }
        return null;
      }
      try {
        let original = await fetch(f.src);
        let upload = await original.blob();
        upload.name = this.p.id;
        console.log(upload);
        var fileExtension = upload.type.split("/")[1];
        var fileName = upload.name + "." + fileExtension;
        const filesize = Math.floor(upload.size / 1024);
        const storage = getStorage();

        const metadata = {
          contentType: upload.type,
        };
        const media = {
          title: fileName,
          extension: fileExtension,
          class: "media",
          created_at: Math.floor(Date.now() / 1000),
          created_by: this.userProfile.uid,
          created_by_email: this.userProfile.email,
          workspace: this.userProfile.workspace,
          size: filesize,
          posts: [],
          templates: [],
          thumbnail: f.src,
          tags: [],
          type: isType(fileExtension),
        };
        const docRef = await addDoc(
          collection(db, "workspaces", this.userProfile.workspace, "media"),
          media,
        );
        const storageRef = ref(
          storage,
          `${this.userProfile.workspace}/media/${docRef.id}.${fileExtension}`,
        );

        await uploadBytesResumable(storageRef, upload, metadata);

        const downloadURL = await getDownloadURL(storageRef);
        const updateRef = doc(
          db,
          "workspaces",
          this.userProfile.workspace,
          "media",
          docRef.id,
        );

        await updateDoc(updateRef, {
          uid: docRef.id,
          src: downloadURL,
        });

        return { ...media, src: downloadURL, uid: docRef.id };
      } catch (err) {
        console.log("err");
        console.log(err);
        return null;
      }
    },
    async importLinkedin(v) {
      console.log(v);

      this.dialog = false;

      this.$store.commit("setLoading", { type: "general", val: true });
      let media_values = [];
      console.log(this.p.content);
      if (this.p.content?.media?.length > 0) {
        media_values = await Promise.all(
          this.p.content.media.map((m) => this.uploadFile(m.src)),
        );
      } else if (this.p.content?.article) {
        media_values = [
          {
            alt: [],
            type: "url",
            url: this.p.content.article.source,
            src: this.p.content.article.src.src,
            description: this.p.content.article.description,
            language: null,
            title: this.p.content.article.title,
          },
        ];
      }

      console.log("media_values", media_values);
      this.$store.dispatch("fetchMedia");
      let message = this.p.commentary.replace(
        /\{hashtag\|\\"?#\|([^}]+)\}/g,
        "#$1",
      );

      message = message.replace(/\\([()[\]{}<>@|~_])/g, "$1");

      let post = {
        auto_variation: true,
        auto_variation_level: "medium",
        accounts: v.accounts,
        category: v.category ? v.category : "",
        created: Math.floor(Date.now() / 1000),
        created_by: this.userProfile.uid,
        created_by_email: this.userProfile.email,
        recurring: v.recurring,
        scheduled: false,
        schedule_date: null,
        last_publish: Math.floor(this.p.publishedAt / 1000),
        status: v.status,
        media: media_values,
        link_preview: null,
        comment: "",
        workspace: this.userProfile.workspace,
        variations: [
          {
            text: message,
            type: "main",
          },
        ],
        uid: null,
        timezone: this.workspace.timezone,
      };

      console.log(post);
      const addPost = httpsCallable(functions, "postAdd");
      const res = await addPost(post);
      console.log(res);

      media_values.map(async (m) => {
        await updateDoc(
          doc(db, "workspaces", this.userProfile.workspace, "media", m.uid),
          {
            posts: arrayUnion(res.data),
          },
        );
      });
      this.$store.dispatch("fetchPosts");
      this.$store.commit("setLoading", { type: "general", val: false });

      this.$store.commit("setNotification", {
        show: true,
        text: "Your post has been added!",
        type: "primary",
        redirect: `/post?id=${res.data}`,
        action_text: "Open",
      });
    },

    openPost(urn) {
      let url = `https://www.linkedin.com/feed/update/${urn}`;
      window.open(url, "_blank");
    },
    async extractStructure() {
      this.$store.commit("setLoading", { type: "general", val: true });

      const structureExtract = httpsCallable(functions, "structureExtract");
      const res = await structureExtract({
        text: this.cleanText,
      });
      console.log(res.data);
      this.structure = res.data;
      this.structure_dialog = true;

      this.$store.commit("setLoading", { type: "general", val: false });
    },
    openLink(url) {
      window.open(url, "_blank");
    },

    format(text) {
      return text.replace(/\{hashtag\|\\"?#\|([^}]+)\}/g, "#$1");
      //   .replace(/@\[(.*?)\]\(urn:li:(?:person|organization):[^)]+\)/g, "@$1");
    },
    async addStructure() {
      this.$store.dispatch("saveStructure", {
        uid: null,
        text: this.structure.text,
        title: this.structure.title,
      });
      this.structure = {
        text: null,
        title: null,
      };

      this.structure_dialog = false;
      this.$store.commit("setNotification", {
        show: true,
        text: "Structure added!",
        type: "primary",
        icon: "",
      });

      this.$store.dispatch("fetchStructures");
    },
  },
};
</script>

<style lang="scss" scoped>
.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
